export default __webpack_public_path__ + "static/media/hosting.d3cedd97.svg";